<template lang="pug">
v-container(fluid class=" pt-2 pb-0 tw-mb-0 tw-pb-0 tw-h-full tw-overflow-hidden tw-mx-0 tw-px-3 " )
    div( class=" tw-flex tw-flex-col tw-h-full  tw-overflow-hidden ")
        div( class=" tw-flex-col ")
            v-row(dense class="")
                v-col(class="")
                    kubiqa-tasks-add-list-item
        div( class="  tw-flex-col tw-flex-1 tw-overflow-y-scroll tw-overflow-x-hidden tw-pt-2 ")
            template(v-if="!loading && !loadFailed && tasks.length > 0")
                v-row(dense class=" tw-max-h-main tw-overflow-y-scroll")
                    v-col( class=" tw-overflow-y-scroll")
                        draggable(
                            :list="tasks"
                            v-bind="dragOptions"
                            @start="drag = true"
                            @change="checkMove"
                            class="list-group"
                        )
                            div( v-for="task in tasks" :key="task.id" @click="task.fixed != task.fixed" class=" list-group tw-flex tw-my-2 tw-rounded-md tw-overflow-hidden" )
                                kubiqa-tasks-list-item(:task="task")
                v-row(class="tw-mb-10")
                    v-col
            template(v-else-if="!loading && !loadFailed")
                v-row(dense justify="center" align="center" class="tw-max-h-main tw-h-full tw-overflow-y-scroll ")
                    v-col(cols="auto")
                        kubiqa-misc-empty-state(
                          :title="$t('Common.emptyStates.tasksTitle')"
                          :description="$t('Common.emptyStates.tasksBody')"
                          :illustration="require('@/assets/images/illustrations/no-tasks.svg')"
                        )
            template(v-else)
                v-row(dense justify="center" align="center" class="tw-max-h-main tw-h-full")
                    v-col(cols="auto")
                        kubiqa-misc-empty-state(
                          :title="$t('Common.emptyStates.loadErrorTitle')"
                          :description="$t('Common.emptyStates.loadErrorBody')"
                          :action-label="$t('Common.emptyStates.retry')"
                          icon="mdi-alert-circle-outline"
                          @action="init"
                        )
                    
</template>
<script>
export default {
    data() {
        return {
            index: 1,
        loading: true,
        loadFailed: false,
            drag: false
        }
    },
    computed: {
        opportunity(){
            return this.$route.params.id
        },
        tasks:{
            get(){
                return this.$store.getters['opportunities/tasks/list']
            },
            set(tasks){
                this.index++
                this.$store.dispatch('opportunities/tasks/updateTaskList', tasks)
            }  
        },
        dragOptions(){
            return {
                animation: 400,
                group: 'tasks',
                disabled: false,
                ghostClass: 'ghost'
            }
        }
    },
    async mounted(){
        this.init()
    },
    methods: {
      async init(){
        this.loading = true
        const result = await this.$store.dispatch('opportunities/tasks/list', this.opportunity)
        this.loading = false
        this.loadFailed = !Array.isArray(result)
      },
        checkMove(evt) {
            var task = evt.moved.element
            task.order = evt.moved.newIndex
            this.$store.dispatch('opportunities/tasks/update', [this.$route.params.id, task])
            this.$store.dispatch('opportunities/tasks/updateTaskList', this.tasks)
        }
    }
}
</script>
<style lang="css">
.ghost {
  opacity: 0.5;
  background: #fff;
}
.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
</style>
